{
  "tasks": {
    "title": "Feladatok",
    "description": "Feladatok, amelyeket egy kolléga vagy egy alkalmazás adott Önnek",
    "columns": {
      "title": "Feladat",
      "createdBy": "Létrehozta",
      "dueAt": "Határidő",
      "source": "Hivatkozás"
    },
    "markDone": "Kész",
    "openSource": "Megnyitás",
    "empty": "Nincs nyitott feladat",
    "search": "Feladatok keresése...",
    "completed": "„{{title}}” elkészült",
    "completeFailed": "A feladatot nem sikerült lezárni",
    "review": "Megtekintés"
  },
  "myTasks": {
    "title": "Feladataim",
    "description": "Minden, ami éppen az Ön beavatkozására vár",
    "openProcessesTitle": "Nyitott folyamatok",
    "openProcessesDescription": "Az Ön felelősségi körébe tartozó folyamatok, amelyek felvételét még nem kezdte el",
    "inProgressRecordingsTitle": "Folyamatban lévő rögzítések",
    "inProgressRecordingsDescription": "Folyamatlépések, amelyek leírását megkezdte, de még nem fejezte be",
    "assignmentsTitle": "Hozzárendeléseim",
    "assignmentsDescription": "Önhöz rendelt folyamatlépések, amelyek az Ön beavatkozására várnak.",
    "pendingSurveysTitle": "Függőben lévő felmérések",
    "pendingSurveysDescription": "Visszajelzés adása a rögzített folyamatlépésekről",
    "pendingReviewsTitle": "Függőben lévő áttekintések",
    "pendingReviewsDescription": "Hagyja jóvá vagy utasítsa el a felvétel során javasolt rendszereket és funkciókat",
    "noPendingReviews": "Nincs függőben lévő áttekintés",
    "searchPendingReviews": "Áttekintések keresése...",
    "review": "Áttekintés",
    "kind": "Típus",
    "name": "Név",
    "submittedBy": "Beküldte",
    "source": "Felvételben javasolva",
    "submittedAt": "Beküldve",
    "openSourceRecording": "Felvétel megnyitása",
    "unnamedProcess": "Névtelen folyamat",
    "process": "Folyamat",
    "department": "Osztály",
    "processOwner": "Folyamattulajdonos",
    "processStep": "Folyamatlépés",
    "previousProcessStep": "Előző folyamatlépés",
    "processStart": "Folyamat kezdete",
    "processStepGeneric": "Folyamatlépés",
    "newStep": "Új folyamatlépés-hozzárendelés",
    "unclearResolution": "Nem egyértelmű következő felelős",
    "decisionStep": "Döntési lépés",
    "dueDate": "Határidő",
    "startedDate": "Kezdés dátuma",
    "assignedBy": "Hozzárendelő",
    "startRecording": "Rögzítés indítása",
    "completeSurvey": "Felmérés kitöltése",
    "noOpenProcesses": "Nem találhatók nyitott folyamatok",
    "noInProgressRecordings": "Nem találhatók folyamatban lévő rögzítések",
    "noAssignments": "Nem találhatók függőben lévő hozzárendelések",
    "noPendingSurveys": "Nem találhatók függőben lévő felmérések",
    "searchInProgressRecordings": "Rögzítések keresése...",
    "searchSurveys": "Felmérések keresése...",
    "searchOpenProcesses": "Folyamatok keresése...",
    "searchAssignments": "Hozzárendelések keresése...",
    "noTasksTitle": "Minden feladat kész!",
    "noTasksDescription": "Jelenleg semmi sem várja Önt. Az új feladatok automatikusan itt jelennek meg.",
    "variantAnswerSaved": "Válasz elmentve",
    "variantAnswerFailed": "A válasz mentése nem sikerült",
    "surveySubmitFailed": "Nem sikerült a felmérés beküldése"
  },
  "assignmentReview": {
    "previousStep": "Előző lépés",
    "outputLabel": "Kimenet:",
    "stepInfoUnavailable": "A lépés információi nem elérhetők",
    "accept": "Kijelölés",
    "deny": "Ne jelöljenek ki",
    "successAcceptedTitle": "Sikeresen hozzárendelve!",
    "successAcceptedDesc": "Most megkezdheti a folyamatlépés leírását.",
    "successRejectedTitle": "Köszönjük visszajelzését!",
    "successRejectedDesc": "A folyamatlépés újra lesz rendelve.",
    "finish": "Befejezés",
    "mergeSectionTitle": "Ez a lépés már létezhet ebben a folyamatban",
    "mergeSectionDescription": "Az újbóli rögzítés helyett összevonhatja ezt a hozzárendelést egy meglévő lépéssel.",
    "mergeInto": "Összevonás ezzel a lépéssel",
    "mergeConfirmTitle": "Hozzárendelés összevonása?",
    "mergeConfirmDescription": "Ez a hozzárendelés a(z) \"{{stepName}}\" lépéshez lesz kapcsolva új rögzítés létrehozása helyett. Ez a művelet nem vonható vissza.",
    "mergeConfirm": "Összevonás",
    "mergeCancel": "Mégse",
    "mergeError": "Nem sikerült a hozzárendelés összevonása",
    "unnamedStep": "Névtelen lépés",
    "selectMergeCandidate": "Válasszon lépést az összevonáshoz…",
    "searchMergeCandidates": "Lépések keresése…",
    "noMergeCandidates": "Nem található megfelelő lépés.",
    "systemAssigneeHintTitle": "Ezt a lépést egy rendszer hajtja végre",
    "systemAssigneeHintDescription": "Te vagy megadva a rendszer felelőseként. Írd le, mit csinál a rendszer – ne azt, amit te magad teszel.",
    "externalContactAssigneeHintTitle": "Ezt a lépést egy külső kapcsolattartó hajtja végre",
    "externalContactAssigneeHintDescription": "Ön a nevében rögzíti ezt a lépést. Írja le, mit csinál a külső kapcsolattartó — nem azt, amit Ön csinál."
  },
  "reassignContext": {
    "title": "Következő felelős kijelölése",
    "descriptionPending": "Válasszon új felelőst — vagy jelölje meg a lépést nem egyértelműként, ha még nem ismert, ki veszi át.",
    "descriptionPendingUnclear": "Oldja fel a nem egyértelmű hozzárendelést: válassza ki, ki veszi át a következő lépést.",
    "descriptionRecording": "Válasszon új felelőst — vagy jelölje meg a lépést nem egyértelműként, ha még nem ismert, ki veszi át.",
    "unclearAlertTitle": "Hozzárendelés nem egyértelműnek jelölve",
    "unclearAlertDescription": "Ez a hozzárendelés Önhöz, a folyamattulajdonoshoz került, mert a felvétel során nem lett meghatározva, ki veszi át a következő lépést. Tekintse át a lépés részleteit, és jelöljön ki egy következő felelőst.",
    "markedUnclearBy": "Nem egyértelműnek jelölte",
    "stepDetails": "Lépés részletei",
    "currentStep": "Újrahozzárendelt lépés",
    "assignToHeading": "Hozzárendelés",
    "chooseAssignee": "Személy, funkció vagy rendszer kiválasztása",
    "markedUnclear": "Nem egyértelműnek jelölve",
    "confirm": "Folytatás"
  },
  "celebration": {
    "banner": {
      "title": "Köszönjük az elkötelezettségét!",
      "description_one": "Ön most teljesített 1 feladatot.",
      "description_other": "Ön most teljesített {{count}} feladatot.",
      "doneCount": "{{count}} kész",
      "openCount": "{{count}} nyitott"
    },
    "recordingStarted": {
      "title": "A rögzítés elindult!",
      "description": "A(z) „{{process}}” folyamat elindult: az első résztvevők meghívást kaptak, és most leírják a lépéseiket."
    },
    "survey": {
      "title": "Köszönjük a visszajelzését!",
      "remaining_one": "Még 1 felmérés vár Önre – körülbelül egy percet vesz igénybe.",
      "remaining_other": "Még {{count}} felmérés vár Önre – mindegyik körülbelül egy percet vesz igénybe.",
      "allDone": "Minden felmérés elkészült. Így a csapata tudja, hogyan zajlik valójában a munka.",
      "nextSurvey": "Következő felmérés"
    },
    "step": {
      "title": "Kész!",
      "description": "A lépése mostantól a(z) „{{process}}” folyamat része. Köszönjük, hogy megosztja a tudását!",
      "startSurvey": "Rövid felmérés indítása (kb. 1 perc)"
    },
    "toTasks": "Ugrás a feladataimhoz",
    "later": "Később"
  },
  "approvals": {
    "status": {
      "approved": "Jóváhagyva",
      "executed": "Végrehajtva",
      "rejected": "Elutasítva",
      "overridden": "Jóváhagyás nélkül folytatva",
      "withdrawn": "Visszavonva",
      "pending": "Nyitott"
    },
    "card": {
      "progress": "{{total}}-ből {{count}} jóváhagyta",
      "requestedBy": "Kérte: {{name}}, {{date}}",
      "due": "határidő: {{date}}",
      "reviewers": "Jóváhagyók",
      "reviewersNeeded_one": "{{total}}-ből {{count}} jóváhagyása szükséges",
      "reviewersNeeded_other": "{{total}}-ből {{count}} jóváhagyása szükséges",
      "verdict": {
        "open": "még nyitott",
        "approved": "jóváhagyta ({{date}})",
        "rejected": "elutasította ({{date}})"
      },
      "overriddenBy": "{{name}} jóváhagyás nélkül folytatta ({{date}})",
      "rejectReason": "Az elutasítás oka",
      "rejectReasonPlaceholder": "Miért? A kérelmező elolvassa az indoklást.",
      "approve": "Jóváhagyás",
      "reject": "Elutasítás",
      "confirmReject": "Elutasítás indoklással",
      "withdraw": "Visszavonás",
      "openRecord": "Megnyitás",
      "override": "Folytatás jóváhagyás nélkül"
    },
    "override": {
      "title": "Folytatás jóváhagyás nélkül?",
      "warning": "Ez megkerüli a négy szem elvét. A jóváhagyók értesítést kapnak, a kérés kihagyottként naplózódik.",
      "confirm": "Folytatás jóváhagyás nélkül",
      "reason": "Indoklás",
      "reasonPlaceholder": "Miért nem lehet várni?"
    },
    "recipients": {
      "intro_one": "Ez a személy feladatot kap:",
      "intro_other": "Ez a(z) {{count}} személy feladatot kap:",
      "due": "Határidő: {{date}}.",
      "required": "{{total}}-ből {{count}} jóváhagyása szükséges."
    },
    "dialogTitle": "Jóváhagyás",
    "actionFailed": "A művelet nem sikerült",
    "toast": {
      "approved": "Jóváhagyva",
      "rejected": "Elutasítva",
      "overridden": "Jóváhagyás nélkül folytatva",
      "withdrawn": "Visszavonva"
    },
    "title": "Jóváhagyások",
    "descriptionAll": "A munkaterület összes jóváhagyása",
    "descriptionMine": "Az általad kért vagy ellenőrzött jóváhagyások",
    "empty": "Nincsenek jóváhagyások",
    "search": "Jóváhagyások keresése",
    "columns": {
      "label": "Mi",
      "status": "Állapot",
      "requestedBy": "Kérte",
      "reviewers": "Jóváhagyók",
      "requestedAt": "Kérés dátuma"
    }
  }
}
